import { render, staticRenderFns } from "./DsSpinner.vue?vue&type=template&id=71d0f549&scoped=true&"
import script from "./DsSpinner.vue?vue&type=script&lang=js&"
export * from "./DsSpinner.vue?vue&type=script&lang=js&"
import style0 from "./DsSpinner.vue?vue&type=style&index=0&id=71d0f549&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d0f549",
  null
  
)

export default component.exports